import React from 'react';

const LineDotsSvg = ({ size = 18 }: { size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 18 18" fill="currentColor" aria-hidden>
    <circle cx="3.75" cy="9" r="1.2" />
    <circle cx="9" cy="9" r="1.2" />
    <circle cx="14.25" cy="9" r="1.2" />
  </svg>
);

export default LineDotsSvg;
